module.exports = __webpack_public_path__ + "pdf.png?7a79c991bd633c76cb48162f9ef0139c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/attachment-format/pdf.png
// module id = 50
// module chunks = 0